import { serverCall } from 'utils/serverCall';
import {
  initFluidHandlerListRequest,
  setFluidHandlerList,
  errorFluidHandlerList,
  initSingleFluidHandlerRequest,
  setSingleFluidHandler,
  errorSingleFluidHandler
} from './action';
import apiEndpoints from 'utils/apiList';

export const fetchFluidHandlerList = () => {
  return async (dispatch) => {
    dispatch(initFluidHandlerListRequest());
    try {
      const result = await serverCall(`${apiEndpoints.FLUID_HANDLER_GET_ALL}`, 'GET', dispatch);

      if (result.success) {
        dispatch(setFluidHandlerList(result.data.payload));
      } else {
        dispatch(errorFluidHandlerList(result.message));
      }
    } catch (error) {
      dispatch(errorFluidHandlerList(error.message));
    }
  };
};

export const fetchSingleFluidHandler = (id) => {
  return async (dispatch) => {
    dispatch(initSingleFluidHandlerRequest(id));

    try {
      const result = await serverCall(`${apiEndpoints.FLUID_HANDLER_GET_SINGLE}/${id}`, 'GET', dispatch);

      if (result.success) {
        dispatch(setSingleFluidHandler(result.data.payload));
      } else {
        dispatch(errorSingleFluidHandler(result.message));
      }
    } catch (error) {
      dispatch(errorSingleFluidHandler(error.message));
    }
  };
};
